import { Card, Icon } from '@mui/material';
import Loading from 'components/Loading';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import React from 'react';

const TopUsedParts = React.memo(({ data, isLoading = false }) => {
    return (
        <Card sx={{ height: '97.2%', display: 'flex', flexDirection: 'column', mt: 1 }}>
            <MDBox justifyContent="space-between" pt={2} px={2} pb={2}>
                <MDBox justifyContent="space-between" display="flex" alignItems="center">
                    <MDBox
                        variant="gradient"
                        bgColor="dark"
                        color="white"
                        coloredShadow="dark"
                        borderRadius="xl"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="4rem"
                        height="4rem"
                        mt={-3}
                    >
                        <Icon fontSize="medium" color="inherit">trending_up</Icon>
                    </MDBox>
                    <MDTypography variant="h6" textTransform="capitalize" fontWeight="light" color="dark">
                        Top Used Parts (30 days)
                    </MDTypography>
                </MDBox>
                <MDBox textAlign="right" lineHeight={1.25} flex={1}>
                    {isLoading ? (
                        <MDBox display="flex" justifyContent="flex-end" mt={1}>
                            <Loading size={20} />
                        </MDBox>
                    ) : (
                        <MDBox mt={2}>
                            {data && data.length > 0 ? (
                                data.map((part, index) => (
                                    <MDBox
                                        key={part.sparepart_id}
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        py={0.3}
                                        borderBottom={index < data.length - 1 ? 1 : 0}
                                        borderColor="grey.200"
                                    >
                                        <MDTypography variant="subtitle2" sx={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: 'black'
                                        }}>
                                            {part.name ?? part.sparepart_name}
                                        </MDTypography>
                                        <MDBox
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            minWidth="24px"
                                            height="32px"
                                            borderRadius="10px"
                                            bgcolor="success.main"
                                            color="white"
                                            ml={1}
                                        >
                                            <MDTypography variant="standard" fontWeight="bold" fontSize="1rem">
                                                {part.total_used ?? part.quantity}
                                            </MDTypography>
                                        </MDBox>
                                    </MDBox>
                                ))
                            ) : (
                                <MDTypography variant="caption" color="text" textAlign="center">
                                    No data
                                </MDTypography>
                            )}
                        </MDBox>
                    )}
                </MDBox>
            </MDBox>
        </Card>
    );
});

TopUsedParts.displayName = 'TopUsedParts';

export default TopUsedParts;